module.exports = __webpack_public_path__ + "assets/img/icon8-menu.95a8feaf.svg";